var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-breadcrumb',{staticClass:"mb-24px",attrs:{"items":_vm.breadcrumbs}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }